export default __webpack_public_path__ + "static/media/flag-equatorial-guinea.094f52d3.svg";